<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="18">
				<div class="centext-box">
					<div class="header">
						新增代理
					</div>
					<div style="padding: 30px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="代理码" prop="agent_code">
								<el-input type="text" placeholder="请输入代理码" size="small" v-model="ruleForm.agent_code"
									style="width: 300px;"></el-input>
								<div style="font-size: 13px;">(代理人登录代理端就能看到，复制发给你)</div>
							</el-form-item>
							<el-form-item label="代理人备注">
								<el-input type="text" placeholder="请输入代理人备注" size="small" v-model="ruleForm.one"
									style="width: 300px;"></el-input>
								<div style="font-size: 13px;">(默认为代理人ID)</div>
							</el-form-item>
							
							<el-form-item label="所属软件" prop="software">
								<el-select v-model="ruleForm.software" clearable placeholder="请选择所属软件"
									style="width: 300px;margin-right: 10px;" size="small">
									<el-option v-for="(item,index) in software_list" :key="index" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="是否限制代理时间">
								<el-radio-group v-model="ruleForm.limit_endtime">
									<el-radio :label="1">限制</el-radio>
									<el-radio :label="0">不限制</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="代理权限到期时间" prop="endtime" v-if="ruleForm.limit_endtime===1">
								<el-date-picker size="small" v-model="ruleForm.endtime" type="datetime"
									placeholder="选择到期时间" style="width: 300px;">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="是否可以开子代理" >
								<el-radio-group v-model="ruleForm.could_child">
									<el-radio :label="1">可以</el-radio>
									<el-radio :label="0">不可以</el-radio>
								</el-radio-group>
							</el-form-item>
							
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">立即创建</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				ruleForm: {
					agent_code: '',
					could_child: 1,
					limit_endtime: 0,
					one: '',
					endtime: '',
					software: '',
				},
				rules: {
					software: [{
						required: true,
						message: '请选择代理软件',
						trigger: 'change'
					}],
					agent_code: [{
						required: true,
						message: '请输入代理码',
						trigger: 'blur'
					}],
					endtime: [{
						required: true,
						message: '请选择代理到期时间',
						trigger: 'change'
					}],
				},
				type_config: {},
				software_list: [],
				card_state_conf: {},
			}
		},
		created() {
			this.resetForm()
			this.getData()
		},
		methods: {

			getData() {
				this.$H.post('verify_center/v1_0_1.Software/list').then(res => {
					if(res.data){
						this.software_list = res.data.list;
					}
					
				});
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('/verify_center/v1_0_1.Agent/Create', this.ruleForm).then(res => {
							if(res.data){
								this.$message.success('添加成功')
								this.$emit('back')
							}
						
						}).catch(err => {
							console.log(err)
							this.$emit('back')
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>